<template>
  <component-wrapper class="contact-person-fi">
    <grid-container-fi grid-class="contact-person-fi__content">
      <div class="fi-col-start-1 fi-col-end-13 lg:fi-col-start-2 lg:fi-col-end-11">
        <div class="contact-person-fi__center-container">
          <div class="contact-person-fi__headline">
            <headline-fi
              v-if="(isEditMode && fields.subheadline) || fields.subheadline?.value"
              class="fi-mb-12"
              tag="div"
              color="brand"
              :size="30"
              :html-content="isEditMode ? fields.subheadline.editable : fields.subheadline?.value"
            />
            <headline-fi
              v-if="(isEditMode && fields.headline) || fields.headline?.value"
              tag="h3"
              :size="60"
              :html-content="isEditMode ? fields.headline.editable : fields.headline?.value"
            />
          </div>
          <div class="contact-person-fi__layout">
            <div class="contact-person-fi__contact-details">
              <div
                class="contact-person-fi__contact-details-column contact-person-fi__contact-details-column--left"
              >
                <div class="contact-person-fi__contact-details-head">
                  <!-- eslint-disable vue/no-v-html -->
                  <div
                    v-if="(isEditMode && fields.name) || fields.name?.value"
                    class="contact-person-fi__name contact-person-fi__detail-line"
                    v-html="isEditMode ? fields.name.editable : legalisedContent(fields.name.value)"
                  />
                  <div
                    v-if="(isEditMode && fields.role) || fields.role?.value"
                    class="contact-person-fi__role contact-person-fi__detail-line"
                    v-html="isEditMode ? fields.role.editable : legalisedContent(fields.role.value)"
                  />
                  <!-- eslint-enable vue/no-v-html -->
                </div>
                <contact-details-fi />
              </div>
            </div>
            <div class="contact-person-fi__image-container">
              <!-- eslint-disable vue/no-v-html -->
              <span
                v-if="isEditMode && fields.image"
                class="contact-person-fi__image"
                v-html="fields.image.editable"
              />
              <!-- eslint-enable vue/no-v-html -->
              <div
                v-else-if="fields.image?.value?.src"
                class="contact-person-fi__image-padding"
              >
                <div class="contact-person-fi__image">
                  <cloud-image-fi
                    :src="fields.image?.value?.src"
                    :alt="fields.image?.value?.alt"
                    params="func=crop&org_if_sml=0"
                    full-height
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </grid-container-fi>
  </component-wrapper>
</template>

<script setup lang="ts">
import { HeadlineFi } from 'atoms';

import CloudImageFi from '@/components/atoms/cloud-image-fi/CloudImageFi.vue';
import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import ContactDetailsFi from '@/components/contact-details-fi/ContactDetailsFi.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import { useLegalisedContent } from '@/composables/legalisedContent';

defineOptions({ name: 'ContactPersonFi' });

withDefaults(
  defineProps<{
    fields?: Record<string, any>;
  }>(),
  {
    fields: () => ({}),
  },
);

const { legalisedContent } = useLegalisedContent();
</script>

<style scoped src="./contact-person-fi" />
